import { render, staticRenderFns } from "./GlobalCoefficients.vue?vue&type=template&id=041e35a0&scoped=true&"
import script from "./GlobalCoefficients.vue?vue&type=script&lang=ts&"
export * from "./GlobalCoefficients.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalCoefficients.vue?vue&type=style&index=0&id=041e35a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041e35a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCol,VContainer,VForm,VIcon,VRow,VSheet,VSlider,VSubheader})
